import { Dialog, DialogTitle } from '@material-ui/core';
import {
  Button, Input, Select, Checkbox, Label,
} from '@ipc/ipc-components';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAllImpcList } from '../../../../../common/impc/redux/selectors/ImpcSelectors';
import {
  getInboundDataLocationsList,
  getMrdStatuses,
  getMrdTypes,
  getPostalOperators,
} from '../../redux/selectors/DeviceInformationSelectors';
import {
  editMrdRequestActionCreator,
  getInboundDataLocationsRequestActionCreator,
  getMrdFormFieldsRequestActionCreator,
} from '../../redux/actions/DeviceInformationActions';
import { getAllIataCodes } from '../../../flight-information/redux/selectors/FlightInformationSelectors';
import { EditMrdDialogStyle } from './EditMrdDialog.styles';
import { getAllIataCodesRequestActionCreator } from '../../../flight-information/redux/actions/FlightInformationActions';
import { formatMessage } from '../../../../../../locales/locales';

function EditMrdDialog(props) {
  const {
    closeDialog,
    openDialog,
    getEditFormFields,
    selectedRow,
    mrdTypeList,
    mrdStatusList,
    impcList,
    iataCodeList,
    postalOperatorList,
    activeMrdList,
    inactiveMrdList,
    inboundDataLocationList,
    editMrdRequest,
    getAllIata,
    getInboundDataLocationList,
  } = props;

  const [deviceType, setDeviceType] = useState({ value: selectedRow.deviceType.code, label: selectedRow.deviceType.description });
  const [mrdStatus, setMrdStatus] = useState({ value: selectedRow.mrdStatus.code, label: selectedRow.mrdStatus.description });
  const [physicalMrd, setPhysicalMrd] = useState(selectedRow.physicalMrd || false);
  const [impc, setImpc] = useState(selectedRow.impc);
  const [dataLocation, setDataLocations] = useState(selectedRow.dataLocation !== null
    ? {
      value: inboundDataLocationList.filter((item) => item.dataLocation === selectedRow.dataLocation).map((i) => i.id)[0],
      label: selectedRow.dataLocation,
    } : '');

  const [airport, setAirport] = useState(selectedRow.airport);
  const [operator, setOperator] = useState(selectedRow.operator);
  const [macAddress, setMacAddress] = useState(selectedRow.macAddress === null ? '' : selectedRow.macAddress);
  const [macAddressErrorMessage, setMacAddressErrorMessage] = useState('');

  const [kioskModel, setKioskModel] = useState(selectedRow.kioskModel === null ? '' : selectedRow.kioskModel);
  const [printerModel, setPrinterModel] = useState(selectedRow.printerModel === null ? '' : selectedRow.printerModel);
  const [scannerModel, setScannerModel] = useState(selectedRow.scannerModel === null ? '' : selectedRow.scannerModel);

  const [teamViewerId, setTeamViewerId] = useState(selectedRow.teamViewerId === null ? '' : selectedRow.teamViewerId);

  const handleDeviceType = (selectedDeviceType) => {
    setDeviceType(selectedDeviceType);
  };

  const handleMrdStatus = (selectedMrdStatus) => {
    setMrdStatus(selectedMrdStatus);
  };

  const handlePhysicalMrd = (e) => {
    setPhysicalMrd(e.target.checked);
  };

  const handleAirport = (selectedAirport) => {
    setAirport(selectedAirport.value);
  };

  const handleOperator = (selectedOperator) => {
    setOperator(selectedOperator.value);
  };

  const handleImpc = (selectedImpc) => {
    setImpc(selectedImpc.value);
  };

  const handleMacAddress = (e) => {
    setMacAddress(e.target.value.toUpperCase());
  };

  const handleKioskModel = (e) => {
    setKioskModel(e.target.value);
  };

  const handlePrinterModel = (e) => {
    setPrinterModel(e.target.value);
  };

  const handleScannerModel = (e) => {
    setScannerModel(e.target.value);
  };

  const handleTeamViewerId = (e) => {
    setTeamViewerId(e.target.value);
  };

  const handleDataLocation = (selectedDataLocation) => {
    setDataLocations(selectedDataLocation);
  };

  const keyPressHandle = (e) => {
    const re = /[a-fA-F\d-]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };
  async function confirmSave() {
    await editMrdRequest({
      mrdName: selectedRow.mrdName,
      deviceType: deviceType.value,
      mrdStatus: mrdStatus.value,
      airport,
      impc,
      operator,
      physicalMrd,
      dataLocationId: (dataLocation === '' || dataLocation.value === -1) ? null : dataLocation.value,
      macAddress: macAddress === '' ? null : macAddress,
      kioskModel: kioskModel === '' ? null : kioskModel,
      printerModel: printerModel === '' ? null : printerModel,
      scannerModel: scannerModel === '' ? null : scannerModel,
      teamViewerId: teamViewerId === '' ? null : teamViewerId,
    });
  }

  const isFormValid = () => !!deviceType && !!mrdStatus && !!impc && !!airport && !!operator && macAddressErrorMessage === '';

  const getMacAddressMessage = (value) => {
    const invalidMessage = formatMessage('en', 'device.information.mac.address.validation.message');
    const notUniqueMessage = formatMessage('en', 'device.information.mac.address.unique.validation.message');
    const macAddressRegex = /^([0-9A-F]{2}[-]){5}([0-9A-F]{2})$/;

    const duplicateMacControl = (mrdObject) => {
      if (!mrdObject.macAddress) return false;
      return mrdObject.macAddress.toUpperCase() === value.toUpperCase();
    };

    if (value !== '' && !macAddressRegex.test(value)) return invalidMessage;

    if (value !== selectedRow.macAddress) {
      const isDuplicate = activeMrdList.some(duplicateMacControl) || inactiveMrdList.some(duplicateMacControl);
      return isDuplicate ? notUniqueMessage : '';
    }
    return '';
  };

  useEffect(() => {
    setMacAddressErrorMessage(getMacAddressMessage(macAddress));
  }, [macAddress]);

  useEffect(() => {
    if (openDialog) {
      getEditFormFields();
      getAllIata({ params: { all: 'Y', iataSort: true } });
    }
  }, [openDialog]);

  useEffect(() => {
    getInboundDataLocationList();
  }, []);
  return (
    <Dialog className="mrd-edit-dialog" onClose={closeDialog} aria-labelledby="simple-dialog-title" open={openDialog}>
      <EditMrdDialogStyle>
        <DialogTitle id="simple-dialog-title">Edit MRD</DialogTitle>
        <div className="mrd-edit-form-body">
          <div className="mrd-edit-dialog-row">
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>MRD name</Label>
              </div>
              <div className="disabled-input form-input-fields">
                <Input
                  type="text"
                  value={selectedRow.mrdName}
                  placeholder={selectedRow.mrdName}
                  disabled
                />
              </div>
            </div>
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>Physical MRD</Label>
              </div>
              <div className="form-input-fields">
                <Checkbox
                  checked={physicalMrd}
                  onChange={handlePhysicalMrd}
                />
              </div>
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>Device type*</Label>
              </div>
              <div className="form-input-fields">
                <Select
                  value={deviceType.value}
                  placeholder={deviceType.label || 'Select...'}
                  options={mrdTypeList.map((type) => ({
                    value: type.code,
                    label: type.description,
                  }))}
                  onChange={handleDeviceType}
                />
              </div>
            </div>
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>MRD status*</Label>
              </div>
              <div className="form-input-fields">
                <Select
                  value={mrdStatus.value}
                  placeholder={mrdStatus.label || 'Select...'}
                  options={mrdStatusList.map((status) => ({
                    value: status.code,
                    label: status.description,
                  }))}
                  onChange={handleMrdStatus}
                />
              </div>
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>IMPC*</Label>
              </div>
              <div className="form-input-fields">
                <Select
                  value={impc}
                  placeholder={impc || 'Select...'}
                  options={impcList.map((element) => ({
                    value: element.impc,
                    label: element.impc,
                  }))}
                  onChange={handleImpc}
                />
              </div>
            </div>
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>Airport (IATA)*</Label>
              </div>
              <div className="form-input-fields">
                <Select
                  value={airport}
                  placeholder={airport || 'Select...'}
                  options={iataCodeList.map((iata) => ({
                    value: iata.iata,
                    label: iata.iata,
                  }))}
                  onChange={handleAirport}
                />
              </div>
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>Operator*</Label>
              </div>
              <div className="form-input-fields">
                <Select
                  value={operator}
                  placeholder={operator || 'Select...'}
                  options={postalOperatorList.map((element) => ({
                    value: element,
                    label: element,
                  }))}
                  onChange={handleOperator}
                  maxMenuHeight={250}
                />
              </div>
            </div>
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>Data Location</Label>
              </div>
              <div className="form-input-fields" style={{ width: '220px' }}>
                <Select
                  value={dataLocation.value}
                  placeholder={dataLocation.label || 'Select...'}
                  onChange={handleDataLocation}
                  options={[{ value: -1, label: 'Select a location' }].concat(inboundDataLocationList.map((element) => ({
                    value: element.id,
                    label: element.dataLocation,
                  })))}
                />
              </div>
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="mrd-edit-dialog-side">
              <div className="form-input-fields">
                <Label>MAC Address</Label>
              </div>
              <div className="form-input-fields">
                <Input
                  type="text"
                  value={macAddress}
                  maxLength={17}
                  onChange={handleMacAddress}
                  onKeyPress={(e) => keyPressHandle(e)}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
            </div>
            <div className="mrd-edit-dialog-side">
              {macAddress && (macAddressErrorMessage !== '') && (
                <span className="unique-mac-error">
                  {macAddressErrorMessage}
                </span>
              )}
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="form-input-fields">
              <Label>Kiosk model</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={kioskModel}
                maxLength={35}
                onChange={handleKioskModel}
              />
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="form-input-fields">
              <Label>Printer model</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={printerModel}
                maxLength={35}
                onChange={handlePrinterModel}
              />
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="form-input-fields">
              <Label>Scanner model</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={scannerModel}
                maxLength={35}
                onChange={handleScannerModel}
              />
            </div>
          </div>
          <div className="mrd-edit-dialog-row">
            <div className="form-input-fields">
              <Label>Team Viewer ID</Label>
            </div>
            <div className="form-input-fields long-input">
              <Input
                type="text"
                value={teamViewerId}
                maxLength={20}
                onChange={handleTeamViewerId}
              />
            </div>
          </div>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={closeDialog} id="cancel">Cancel</Button>
          <Button
            onClick={confirmSave}
            className={`primary-button-${!isFormValid()} action`}
            disabled={!isFormValid()}
            id="submit"
          >
            Save
          </Button>
        </div>
      </EditMrdDialogStyle>
    </Dialog>
  );
}

EditMrdDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool,
  getEditFormFields: PropTypes.func,
  editMrdRequest: PropTypes.func,
  selectedRow: PropTypes.objectOf(PropTypes.shape),
  mrdTypeList: PropTypes.arrayOf(PropTypes.object),
  mrdStatusList: PropTypes.arrayOf(PropTypes.object),
  postalOperatorList: PropTypes.arrayOf(PropTypes.string),
  impcList: PropTypes.arrayOf(PropTypes.object),
  iataCodeList: PropTypes.arrayOf(PropTypes.object),
  activeMrdList: PropTypes.arrayOf(PropTypes.object),
  inactiveMrdList: PropTypes.arrayOf(PropTypes.object),
  getAllIata: PropTypes.func,
  inboundDataLocationList: PropTypes.arrayOf(PropTypes.object),
  getInboundDataLocationList: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    mrdTypeList: getMrdTypes(state),
    mrdStatusList: getMrdStatuses(state),
    postalOperatorList: getPostalOperators(state),
    impcList: getAllImpcList(state),
    iataCodeList: getAllIataCodes(state),
    inboundDataLocationList: getInboundDataLocationsList(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  editMrdRequest: editMrdRequestActionCreator,
  getEditFormFields: getMrdFormFieldsRequestActionCreator,
  getAllIata: getAllIataCodesRequestActionCreator,
  getInboundDataLocationList: getInboundDataLocationsRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditMrdDialog);
